import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import PageMeta from '../../components/PageMeta';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', motDePasse: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.email, form.motDePasse);
      navigate(`/dashboard/${user.role}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <PageMeta title="Connexion" />
      <div className="w-full max-w-md mx-4">
        <div className="card-root p-8">
          <div className="text-center mb-8">
            <h1 className="font-serif text-3xl font-bold tracking-tight" style={{ color: '#0A192F' }}>Connexion</h1>
            <p className="mt-2 text-sm" style={{ color: '#7A828A' }}>Accédez à votre espace UNIKOL</p>
          </div>

          {error && (
            <div className="mb-6 p-3 text-sm font-semibold uppercase tracking-wider"
              style={{ backgroundColor: '#FFF0F0', color: '#D32F2F', border: '2px solid #D32F2F' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <p className="label-root mb-1.5">Email</p>
              <input type="email" className="input-root" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })} required placeholder="votre@email.com" />
            </div>
            <div>
              <p className="label-root mb-1.5">Mot de passe</p>
              <input type="password" className="input-root" value={form.motDePasse}
                onChange={(e) => setForm({ ...form, motDePasse: e.target.value })} required placeholder="••••••••" />
            </div>
            <button type="submit" className="btn-primary-root w-full py-3" disabled={loading}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>

          <p className="mt-6 text-center text-sm" style={{ color: '#7A828A' }}>
            Pas encore de compte ?{' '}
            <Link to="/register" style={{ color: '#C59B6C', fontWeight: 700 }}>S'inscrire</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
